import { makeSchedulable, SchedulablesController } from "./schedulable_helpers";

export default makeSchedulable(class extends SchedulablesController {
});



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-time-allocation-details-controller.js